import { render, staticRenderFns } from "./myscore.vue?vue&type=template&id=2d78173e&scoped=true&"
import script from "./myscore.vue?vue&type=script&lang=js&"
export * from "./myscore.vue?vue&type=script&lang=js&"
import style0 from "./myscore.vue?vue&type=style&index=0&id=2d78173e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d78173e",
  null
  
)

export default component.exports